export default __webpack_public_path__ + "static/media/wheel-btn.db1d77c9.webp";